export default __webpack_public_path__ + "static/media/icon-contained.e2d56b3a.svg";